import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HTMLFlipBook from "react-pageflip";
import { jsPDF } from "jspdf";
import { FaWhatsapp, FaFacebook, FaInstagram, FaShareAlt } from "react-icons/fa";
import { Download } from "lucide-react";
import "./style.css";

import Image1 from "../../Assets/COMPRESSED/1.jpg";
import Image2 from "../../Assets/COMPRESSED/2.jpg";
import Image3 from "../../Assets/COMPRESSED/3.jpg";
import Image4 from "../../Assets/COMPRESSED/4.jpg";
import Image5 from "../../Assets/COMPRESSED/5.jpg";
import Image6 from "../../Assets/COMPRESSED/6.jpg";
import Image7 from "../../Assets/COMPRESSED/7.jpg";
import Image8 from "../../Assets/COMPRESSED/8.jpg";
import Image9 from "../../Assets/COMPRESSED/9.jpg";
import Image10 from "../../Assets/COMPRESSED/10.jpg";
import Image11 from "../../Assets/COMPRESSED/11.jpg";
import Image12 from "../../Assets/COMPRESSED/12.jpg";
import Image13 from "../../Assets/COMPRESSED/13.jpg";
import Image14 from "../../Assets/COMPRESSED/14.jpg";
import Image15 from "../../Assets/COMPRESSED/15.jpg";
import Image16 from "../../Assets/COMPRESSED/16.jpg";
import Image17 from "../../Assets/COMPRESSED/17.jpg";
import Image18 from "../../Assets/COMPRESSED/18.jpg";
import Image19 from "../../Assets/COMPRESSED/19.jpg";
import Image20 from "../../Assets/COMPRESSED/20.jpg";
import Image21 from "../../Assets/COMPRESSED/21.jpg";
import Image22 from "../../Assets/COMPRESSED/22.jpg";
import Image23 from "../../Assets/COMPRESSED/23.jpg";
import Image24 from "../../Assets/COMPRESSED/24.jpg";
import Image25 from "../../Assets/COMPRESSED/25.jpg";
import Image26 from "../../Assets/COMPRESSED/26.jpg";
import Image27 from "../../Assets/COMPRESSED/27.jpg";
import Image28 from "../../Assets/COMPRESSED/28.jpg";
import Image29 from "../../Assets/COMPRESSED/29.jpg";
import Image30 from "../../Assets/COMPRESSED/30.jpg";
import Image31 from "../../Assets/COMPRESSED/31.jpg";
import Image32 from "../../Assets/COMPRESSED/32.jpg";
import Image34 from "../../Assets/COMPRESSED/New Project.jpg";
import Image35 from "../../Assets/COMPRESSED/New Project.jpg";
import logo from "../../Assets/Group 25.png";

const SkeletonLoader = () => (
  <div className="min-h-screen bg-[#f5f5f0] flex items-center justify-center">
    <div className="flex gap-2 animate-pulse">
      <div className="w-[300px] h-[450px] bg-gray-200 rounded-lg" />
      <div className="w-[300px] h-[450px] bg-gray-100 rounded-lg hidden md:block" />
    </div>
  </div>
);

const Magazine = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const bookRef = useRef(null);
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  const isMobile = windowDimensions.width <= 768;

  const allPages = [
    { image: Image34 },
    { image: Image1 },
    { image: Image2 },
    { image: Image3 },
    { image: Image4 },
    { image: Image5 },
    { image: Image6 },
    { image: Image7 },
    { image: Image8 },
    { image: Image9 },
    { image: Image10 },
    { image: Image11 },
    { image: Image12 },
    { image: Image13 },
    { image: Image14 },
    { image: Image15 },
    { image: Image16 },
    { image: Image17 },
    { image: Image18 },
    { image: Image19 },
    { image: Image20 },
    { image: Image21 },
    { image: Image22 },
    { image: Image23 },
    { image: Image24 },
    { image: Image25 },
    { image: Image26 },
    { image: Image27 },
    { image: Image28 },
    { image: Image29 },
    { image: Image30 },
    { image: Image31 },
    { image: Image32 },
    { image: Image35 },
  ];

  const displayPages = isMobile ? allPages.slice(1, -1) : allPages;
  const pdfPages = allPages.slice(1, -1);

  useEffect(() => {
    const handleResize = () =>
      setWindowDimensions({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const imagePromises = displayPages.map(
      (page) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = reject;
          img.src = page.image;
        })
    );
    Promise.all(imagePromises).then(() => setImagesLoaded(true));
  }, [displayPages]);

  const generatePDF = async () => {
    setIsGeneratingPDF(true);
    const pdf = new jsPDF();
    for (let i = 0; i < pdfPages.length; i++) {
      if (i > 0) pdf.addPage();
      await new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const imgProps = pdf.getImageProperties(img);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          pdf.addImage(img, "JPEG", 0, 0, pdfWidth, pdfHeight);
          resolve();
        };
        img.src = pdfPages[i].image;
      });
    }
    pdf.save("Celandine_The Sunlight Bloom.pdf");
    setIsGeneratingPDF(false);
  };

  const shareToWhatsApp = () =>
    window.open(
      `https://api.whatsapp.com/send?text=Homeeframes Issue 01- Celandine: The Sunlight Bloom: ${encodeURIComponent(shareUrl)}`,
      "_blank"
    );
  const shareToFacebook = () =>
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      "_blank"
    );
  const shareToInstagram = () =>
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => alert("Link copied! Paste it in your Instagram story or post."));
  const shareGeneral = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Celandine: The Sunlight Bloom",
          text: "Check out this amazing magazine!",
          url: shareUrl,
        })
        .catch((error) => console.log("Error sharing", error));
    } else {
      navigator.clipboard.writeText(shareUrl).then(() => alert("Link copied to clipboard!"));
    }
  };

  if (!imagesLoaded) return <SkeletonLoader />;

  return (
    <div className="min-h-screen bg-[#f5f5f0] text-black flex flex-col relative">
      <button
        onClick={() => navigate(-1)}
        className="fixed top-6 left-6 z-50 flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-md border border-black/10 rounded-full text-black hover:bg-black hover:text-white transition-all duration-300 shadow-sm"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        Back
      </button>

      {/* ── HERO TITLE ── */}
      <div className="text-center pt-24 pb-6 px-4">
        <p className="text-xs tracking-[0.3em] uppercase text-black/30 mb-2">
          Homeeframes Magazine
        </p>
        <h1 className="text-3xl md:text-5xl font-bold tracking-tight text-black">
          Celandine:{" "}
          <span className="text-gray-400">The Sunlight Bloom</span>
        </h1>
        <p className="text-black/40 text-sm mt-3 max-w-md mx-auto leading-relaxed">
          A curated editorial on light, space, and architectural warmth.
        </p>
        <div className="flex items-center justify-center gap-4 mt-5">
          <span className="w-16 h-px bg-black/10" />
          <span className="text-black/20 text-xs">✦</span>
          <span className="w-16 h-px bg-black/10" />
        </div>
      </div>

      {/* ── FLIPBOOK ── */}
      <main className="flex-1 flex items-center justify-center w-full px-4 py-8 overflow-x-auto">
        <div className="relative flex items-center justify-center w-full">
          {/* Warm glow behind book */}
          <div className="absolute inset-0 -z-10 blur-[80px] opacity-25 bg-amber-100 rounded-full scale-75" />

          {/* Explicit two-page width: 400×2=800px desktop, 300px mobile */}
          <div style={{ width: isMobile ? "300px" : "800px" }}>
            <HTMLFlipBook
              width={isMobile ? 300 : 400}
              height={isMobile ? 450 : 600}
              size="stretch"
              minWidth={300}
              maxWidth={1000}
              minHeight={400}
              maxHeight={1350}
              maxShadowOpacity={0.5}
              mobileScrollSupport={true}
              ref={bookRef}
              className="magazine"
            >
              {displayPages.map((page, index) => (
                <div key={index} className="page">
                  <div className="page-content">
                    <img
                      src={page.image}
                      alt={`Page ${index + 1}`}
                      className="page-image"
                    />
                  </div>
                </div>
              ))}
            </HTMLFlipBook>
          </div>
        </div>
      </main>

      {/* ── BOTTOM ACTION BAR ── */}
      <footer className="w-full border-t border-black/10 bg-white px-6 py-5">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">

          {/* Share buttons */}
          <div className="flex items-center gap-2">
            <span className="text-black/30 text-xs tracking-widest uppercase mr-2">Share</span>
            {[
              { icon: <FaWhatsapp size={16} />, action: shareToWhatsApp, label: "WhatsApp", color: "hover:bg-[#25D366] hover:text-white" },
              { icon: <FaFacebook size={16} />, action: shareToFacebook, label: "Facebook", color: "hover:bg-[#1877F2] hover:text-white" },
              { icon: <FaInstagram size={16} />, action: shareToInstagram, label: "Instagram", color: "hover:bg-[#E1306C] hover:text-white" },
              { icon: <FaShareAlt size={16} />, action: shareGeneral, label: "Share", color: "hover:bg-black/10" },
            ].map(({ icon, action, label, color }) => (
              <button
                key={label}
                onClick={action}
                title={label}
                className={`w-9 h-9 rounded-full bg-black/5 border border-black/10 flex items-center justify-center text-black/60 transition-all duration-200 ${color} hover:scale-105`}
              >
                {icon}
              </button>
            ))}
          </div>

          {/* Download button */}
          <button
            onClick={generatePDF}
            disabled={isGeneratingPDF}
            className="flex items-center gap-2 px-6 py-2.5 rounded-full bg-black text-white font-semibold text-sm tracking-wide hover:bg-gray-800 transition-all duration-200 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
          >
            <Download size={15} />
            {isGeneratingPDF ? "Generating PDF…" : "Download PDF"}
          </button>

        </div>
      </footer>

    </div>
  );
};

export default Magazine;
